import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

const DragDropArea = styled.div`
  position: absolute;
  z-index: 1;
  background: transparent;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const Dropzone = ({ setPdfUrl, setImageUrl, onUpload, pdfFormatDisabled }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();

        reader.onload = () => {
          // Do whatever you want with the file contents
          const dataUrl = reader.result;
          if (file.type !== 'application/pdf') {
            setImageUrl(dataUrl);
            setPdfUrl(null);
          } else {
            setImageUrl(null);
            setPdfUrl(dataUrl);
          }

          onUpload(file);
        };
        reader.readAsDataURL(file);
      });
    },
    [onUpload, setImageUrl, setPdfUrl],
  );
  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
    onDrop,
    accept: pdfFormatDisabled
      ? 'image/png, image/jpeg, image/gif'
      : 'image/jpeg, image/png, application/pdf,image/jpg, image/gif',
    maxFiles: 1,
  });

  return (
    <DragDropArea {...getRootProps()} hasData={acceptedFiles.length > 0}>
      <input {...getInputProps()} />
    </DragDropArea>
  );
};

Dropzone.propTypes = {
  setPdfUrl: PropTypes.func,
  setImageUrl: PropTypes.func,
  onUpload: PropTypes.func,
  pdfFormatDisabled: PropTypes.bool,
};

Dropzone.defaultProps = {
  setPdfUrl: Function.prototype,
  setImageUrl: Function.prototype,
  onUpload: Function.prototype,
};

export default Dropzone;
